import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardContent, Typography, CardActions, CardHeader, IconButton, Button, Box, TextField, InputAdornment } from '@mui/material';
import { DeleteIcon, EditIcon, NextIcon } from '../../../../assets/common-svg/CommonSvg';
import SkeletonLoader from '../../../../utilites/SkeltonLoader';
import CustomMenuBar from '../../../../components/custom-menubar/CustomMenuBar';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { clearRolesModule, deleteRole, fetchAllRoles, selectAllRoles, selectBmrRolesLoading } from '../../../slices/roles';
import { SearchIcon } from '../../../assets/CommonSvg';
import { debounce } from 'lodash';
import DeleteModal from '../../../components/common/BaseModal/DeleteModal';
import NoDataCard from '../../../../components/no-data-card';

const options = [
    { id: "edit", optionName: "Edit", optionIcon: <EditIcon />, auth: { module: "rolesManagement", auth: 97 } },
    { id: "delete", optionName: "Delete", optionIcon: <DeleteIcon />, auth: { module: "rolesManagement", auth: 99 } },
];

export default function RolesManagement() {
    const [roles, setRoles] = useState([]);
    const isLoading = useSelector(selectBmrRolesLoading)
    const allRoles = useSelector(selectAllRoles)
    const [searchQuery, setSearchQuery] = useState('');
    const [deleteModal, setDeleteModal] = useState(null);


    const navigate = useNavigate()
    const dispatch = useDispatch()

    const getRoles = async () => {
        await dispatch(fetchAllRoles())
    }

    useEffect(() => {
        const updatedRolesData = allRoles.map(role => ({ ...role, options }));
        setRoles(updatedRolesData);
    }, [allRoles])

    useEffect(() => {
        getRoles()
    }, [])

    const handleDelete = async () => {
        await dispatch(deleteRole(deleteModal))
        setDeleteModal(null)
        getRoles()
    };

    const handleEdit = async (card) => {
        navigate(`/bmr/roles-management/modules/${card?.id}`,{
                state: [
                    { name: "Roles Management", path: location.pathname },
                    { name: 'Edit',
                    path: `/bmr/roles-management/modules/${card.id}`,
                    },
                ]})
    };

    const handleSearch = (value) => {
        if (value) {
            const filterData = roles.filter(role => role.title.toLowerCase().includes(value.toLowerCase()))
            setRoles(filterData)
        }
        else {
            const updatedRolesData = allRoles.map(role => ({ ...role, options }));
            setRoles(updatedRolesData);
        }
        setSearchQuery(value);
    }
    // // // Optimized search implementation
    // const handleSearch = useCallback((query) => {
    //     if (query != searchQuery) {
    //         const filterData = roles.filter(role => role.title.toLowerCase().includes(query.toLowerCase()))
    //         setRoles(filterData)
    //     }
    //     setSearchQuery(query);
    // }, [roles, searchQuery]);

    // Memoized debounced search
    const debouncedSearch = useMemo(
        () => debounce(handleSearch, process.env.DEBOUNCE_DELAY),
        [handleSearch]
    );
    const addRole = async () => {
        await dispatch(clearRolesModule())
        navigate("/bmr/roles-management/modules",{
             state: [
                    { name: "Roles Management", path: location.pathname },
                    { name: 'Add Role',
                    path: `/bmr/roles-management/modules`,
                    },
                ]}
        )
    }
    return (
        <div className="p-3">
            <Box className="flex justify-content-between mb-2">
                <div>
                    <TextField
                        variant="outlined"
                        className="bg-[#fff] w-[325px] py-[2.5px] border-0 rounded-[10px]"
                        size="small"
                        placeholder="Search by role name"
                        sx={{ "& fieldset": { border: 'none' } }}
                        value={searchQuery}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon className="text-gray-500" />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => debouncedSearch(e.target.value)}
                    />
                </div>
                <div>
                    <Button onClick={() => addRole()}>Add Role</Button>
                </div>
            </Box>
            {roles?.length != 0 ? <div className="grid lg:grid-cols-3 sm:grid-cols-1 gap-3">
                {isLoading ? (
                    <SkeletonLoader rowCount={3} isTable={false} width="100%" height={145} />
                ) : (
                    roles?.length != 0 && roles?.map((card, index) => (
                        <Card className="rounded-xl w-100" key={index}>
                            <CardHeader
                                action={
                                    <IconButton aria-label="settings">
                                        <CustomMenuBar
                                            cardId={card.id}
                                            options={card.options}
                                            handleDelete={() => setDeleteModal(card.id)}
                                            handleEdit={() => handleEdit(card)}
                                        />
                                    </IconButton>
                                }
                                title={card.title}
                            />
                            <CardContent>
                                <Typography variant="body1">{card.description}</Typography>
                            </CardContent>
                            <hr className="ml-3 mr-3" />
                            <CardActions className="p-3">
                                <Button
                                    color="primary"
                                    variant="outlined"
                                    endIcon={<NextIcon />}
                                    size="small"
                                    onClick={() => navigate(`/bmr/roles-management/permissions/${card.id}`,
                                          {
                                            state: [
                                                { name: "Roles Management", path: location.pathname },
                                                { name: card?.title,
                                                path: `/bmr/roles-management/permissions/${card.id}`,
                                                },
                                            ]})}>
                                    Details
                                </Button>
                            </CardActions>
                        </Card>
                    ))
                )}
            </div> : <NoDataCard />}
            <DeleteModal
                open={deleteModal}
                setClose={setDeleteModal}
                title={"Are you sure you want to Delete File ?"}
                buttonText={"Delete"}
                handleSuccess={handleDelete}
            />
        </div >
    );
}


